import styled from "styled-components";

export const SettingsContent = styled.div`
  position: relative;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: auto;

  > div {
    flex: 1 1;
  }

  @media (orientation: landscape) {
    padding-left: 2.8em;
  }
`;
